import { css } from '@emotion/css';
import { Color, Font, FontWeight } from 'src/styles';

export const policyLink = css`
  color: ${Color.Brand5};
`;

export const nickname = css`
  ${Font.sm}
  color: ${Color.Gray7};
`;

export const senderReceiverTopLabel = css`
  ${FontWeight.semibold}
  text-transform: uppercase;
  color: ${Color.Gray7};
`;

export const bankLogo = css`
  width: 1.5rem;
  height: 1.5rem;
`;

export const tableContainer = css`
  width: 100%;
`;

export const amountValue = ({ isNegative }: { isNegative: boolean }) => css`
  ${FontWeight.bold}
  ${Font.lg}
  color: ${isNegative ? Color.Red8 : Color.Green8};
`;
